// favicons
import "./resources/favicons/apple-touch-icon.png"
import "./resources/favicons/favicon-32x32.png"
import "./resources/favicons/favicon-16x16.png"
import "./resources/favicons/safari-pinned-tab.svg"

// Stylesheets
import "./theme.scss";
import "./components/experiencefragment/_experiencefragment_header.js"; 
import "./components/embed/_embed_datatrust.js"
import "./components/embed/_embed_datatrust_tables.js"

import "./components/tabs/_tabs_faq.js" 
import "./components/tabs/_tabs-country-selector.js" 

// OneTrust Update Links on Banner & Cookie Settings
import "./components/oneTrust/oneTrustBanner.ts";
import "./components/oneTrust/cookieSettings.ts";
